(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-november-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('black-november-shop')) {
    customElements.define('black-november-shop', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const filters = this.querySelector('.bn-filters');
        if (!filters) return;
        const buttons = [...filters.querySelectorAll('button')];
        const cards = [...this.querySelectorAll('[data-bn-kind]')];
        const guide = this.querySelector('[data-bn-guide]');
        const count = this.querySelector('.bn-offer-count');
        filters.hidden = false;
        filters.addEventListener('click', event => {
          const button = event.target.closest('button[data-bn-filter]');
          if (!button || !filters.contains(button)) return;
          const kind = button.dataset.bnFilter;
          let visible = 0;
          cards.forEach(card => {
            card.hidden = kind !== 'all' && card.dataset.bnKind !== kind;
            if (!card.hidden) visible += 1;
          });
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          if (guide) guide.hidden = kind === 'outdoor';
          if (count) count.textContent = this.dataset.countTemplate.replace('[count]', String(visible));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
